// extracted by mini-css-extract-plugin
export default {"treinoItem":"TreinoItem_treinoItem__90A7M","backdrop":"TreinoItem_backdrop__XIsgK","active":"TreinoItem_active__GtOR5","imgView":"TreinoItem_imgView__pRSci"};